import { render, staticRenderFns } from "./CatalogsNav.vue?vue&type=template&id=f995c938&"
import script from "./CatalogsNav.vue?vue&type=script&lang=js&"
export * from "./CatalogsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports